"use-strict";
var BlsLazyloadImg = (function () {
  return {
    init: function () {
      this.lazyReady();
    },
    lazyReady: function () {
      if (!!window.IntersectionObserver) {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const onImageLoad = (e) => {
                  const target = e.currentTarget;
                  setTimeout(() => {
                    target
                      ?.closest("motion-element")
                      ?.classList.remove("bls-loading-image");
                    target?.classList.remove("bls-loading-image");
                  }, 600);
                  e.currentTarget.removeEventListener("load", onImageLoad);
                };
                entry.target.width = entry.boundingClientRect.width;
                entry.target.height = entry.boundingClientRect.height;
                entry.target.sizes = `${entry.boundingClientRect.width}px`;
                entry.target.addEventListener("load", onImageLoad);
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: "10px" }
        );
        document.querySelectorAll(".bls-image-js img").forEach((img) => {
          observer.observe(img);
        });
      }
    },
  };
})();
BlsLazyloadImg.init();
function CloseAllPopup(data) {
  publish("closeCanvas", data);
}

const imageReady = (imageOrArray) => {
  if (!imageOrArray) {
    return Promise.resolve();
  }
  imageOrArray =
    imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
  return Promise.all(
    imageOrArray.map((image) => {
      return new Promise((resolve) => {
        if (
          (image.tagName === "IMG" && image.complete) ||
          !image.offsetParent
        ) {
          setTimeout(() => {
            image
              .closest("motion-element")
              ?.classList.remove("bls-loading-image");
            image.classList.remove("bls-loading-image");
            resolve();
          }, 100);
        } else {
          image.addEventListener("load", (e) => {
            e.currentTarget
              .closest("motion-element")
              ?.classList.remove("bls-loading-image");
            e.currentTarget.classList.remove("bls-loading-image");
            resolve();
          });
        }
      });
    })
  );
};
class MotionElement extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this.isHold) return;
    this.preInitialize();
    if (this.dataset.noview) {
      return;
    }
    if (!this.isConnected || !document.body.contains(this)) {
      setTimeout(() => {
        this.connectedCallback();
      }, 100);
      return;
    }

    var _this = this;
    let custom_margin = this.dataset.margin || "0px 0px -5px 0px";
    let rootElement = {};
    if (this.dataset.parent) {
      var parent = this.closest(`.${this.dataset.parent}`);
      rootElement = { root: parent };
      custom_margin = "0px 0px 0px 0px";
    }
    Motion.inView(
      _this,
      async () => {
        if (
          !this.isInstant &&
          this.mediaElements &&
          this.hasAttribute("data-image")
        ) {
          await imageReady(this.mediaElements);
        }
        setTimeout(() => {
          _this.initialize();
        }, 50);
      },
      { margin: custom_margin, ...rootElement }
    );
  }

  get isHold() {
    return this.hasAttribute("hold");
  }

  get Transition() {
    let transition = this.getAttribute("data-transition")
      ?.split(",")
      .map(Number);
    return transition || [0, 0, 0.3, 1];
  }

  get isInstant() {
    return this.hasAttribute("data-instantly");
  }

  get mediaElements() {
    return Array.from(this.querySelectorAll("img, iframe, svg"));
  }

  get animationType() {
    return this.dataset.motion || "fade-up";
  }

  get animationDelay() {
    return parseInt(this.dataset.motionDelay || 0) / 1000;
  }

  set animationDelay(value) {
    this.dataset.motionDelay = value;
  }

  preInitialize() {
    if (this.isHold) return;
    switch (this.animationType) {
      case "fade-in":
        Motion.animate(this, { opacity: 0.01 }, { duration: 0 });
        break;

      case "fade-up":
        Motion.animate(
          this,
          { transform: "translateY(2.5rem)", opacity: 0.01 },
          { duration: 0 }
        );
        break;

      case "fade-up-sm":
        Motion.animate(
          this,
          { transform: "translateY(1rem)", opacity: 0.01 },
          { duration: 0 }
        );
        break;

      case "fade-up-lg":
        Motion.animate(
          this,
          { transform: "translateY(4rem)", opacity: 0.01 },
          { duration: 0 }
        );
        break;

      case "zoom-in":
        Motion.animate(this, { transform: "scale(0.8)" }, { duration: 0 });
        break;
      case "zoom-in-lg":
        Motion.animate(this, { transform: "scale(0)" }, { duration: 0 });
        break;

      case "zoom-out":
        Motion.animate(this, { transform: "scale(1.07)" }, { duration: 0 });
        break;

      case "zoom-out-sm":
        Motion.animate(this, { transform: "scale(1.07)" }, { duration: 0 });
        break;
      case "zoom-out-lg":
        Motion.animate(this, { transform: "scale(1.07)" }, { duration: 0 });
        break;
    }
  }

  async initialize() {
    if (this.isHold) return;
    switch (this.animationType) {
      case "fade-in":
        await Motion.animate(
          this,
          { opacity: 1 },
          { duration: 1.5, delay: this.animationDelay, easing: this.transition }
        ).finished;
        break;

      case "fade-up":
        await Motion.animate(
          this,
          { transform: "translateY(0)", opacity: 1 },
          {
            duration: 0.5,
            delay: this.animationDelay,
            easing: this.transition,
          }
        ).finished;
        break;

      case "fade-up-sm":
        await Motion.animate(
          this,
          { transform: "translateY(0)", opacity: 1 },
          {
            duration: 0.3,
            delay: this.animationDelay,
            easing: this.transition,
          }
        ).finished;
        break;

      case "fade-up-lg":
        await Motion.animate(
          this,
          { transform: "translateY(0)", opacity: 1 },
          {
            duration: 0.5,
            delay: this.animationDelay,
            easing: this.transition,
          }
        ).finished;
        break;

      case "zoom-in":
        await Motion.animate(
          this,
          { transform: "scale(1)" },
          { duration: 1.3, delay: this.animationDelay, easing: this.transition }
        ).finished;
        break;

      case "zoom-in-lg":
        await Motion.animate(
          this,
          { transform: "scale(1)" },
          { duration: 0.5, delay: this.animationDelay, easing: this.transition }
        ).finished;
        break;

      case "zoom-out":
        await Motion.animate(
          this,
          { transform: "scale(1)" },
          { duration: 1.5, delay: this.animationDelay, easing: this.transition }
        ).finished;
        break;

      case "zoom-out-sm":
        await Motion.animate(
          this,
          { transform: "scale(1)" },
          { duration: 1, delay: this.animationDelay, easing: this.transition }
        ).finished;
        break;
      case "zoom-out-lg":
        await Motion.animate(
          this,
          { transform: "scale(1)" },
          { duration: 1, delay: this.animationDelay, easing: this.transition }
        ).finished;
        break;
    }
  }
  refreshAnimation() {
    this.removeAttribute("hold");
    this.preInitialize();
    setTimeout(() => {
      this.initialize();
    }, 50); // Delay a bit to make animation re init properly.
  }
}
customElements.define("motion-element", MotionElement);

class SlideSection extends HTMLElement {
  constructor() {
    super();
    this.globalSlide = null;
    this.init();
  }

  init() {
    if (document.body.classList.contains("index")) {
      let pos = window.pageYOffset;
      if (pos > 0 || document.body.classList.contains("swiper-lazy")) {
        this.initSlide();
      } else {
        if (this.classList.contains("lazy-loading-swiper-before")) {
          this.initSlide();
        } else {
          this.classList.add("lazy-loading-swiper-after");
        }
      }
    } else {
      this.initSlide();
    }
  }

  initSlide() {
    const _this = this;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const autoHeight = _this?.dataset.autoHeight === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    this.globalSlide = new Swiper(_this, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      autoHeight: autoHeight,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grabCursor: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el:
          _this.querySelector(".parent-pagination") ||
          _this.querySelector(".swiper-pagination"),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          type: progressbar ? "progressbar" : "bullets",
          autoHeight: false,
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          type: progressbar ? "progressbar" : "bullets",
          autoHeight: false,
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          if (_this.classList.contains("slideshow")) {
            const motionElement = _this.querySelectorAll(
              `.swiper-slide.swiper-slide-active  motion-element.effect_fadeinup`
            );
            setTimeout(() => {
              motionElement &&
                motionElement.forEach((item) => {
                  item.refreshAnimation();
                });
            }, 350);
          }
          var slide_visibles = _this.querySelectorAll(
            ".swiper-slide:not(.swiper-slide-visible) motion-element:not([data-image]),motion-element.swiper-slide:not(.swiper-slide-visible)"
          );
          slide_visibles?.forEach((slide) => {
            if (slide && typeof slide.initialize === "function") {
              slide.initialize();
            }
          });
          e.autoplay.stop();
          if (_this?.dataset.autoplay === "true") {
            Motion.inView(
              _this,
              async () => {
                e.autoplay.start();
              },
              { margin: "0px 0px -50px 0px" }
            );
          }

          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
          var video = _this.querySelector("video.slideshow");
          if (video) {
            const handleIntersection = (entries, observer) => {
              if (!entries[0].isIntersecting) return;
              observer.unobserve(_this);
              const videos = _this.querySelectorAll("video");
              videos.forEach((video) => {
                const dataSrc = video.dataset.src;
                if (dataSrc) {
                  video.src = dataSrc;
                  video.removeAttribute("data-src");
                }
              });
            };
            new IntersectionObserver(handleIntersection.bind(_this), {
              rootMargin: "0px 0px 200px 0px",
            }).observe(_this);
          }
        },
        realIndexChange: function (swiper) {
          if (_this?.dataset.autoplay) {
            var slide_visibles = _this.querySelectorAll(
              ".swiper-slide motion-element:not([data-image])"
            );
            slide_visibles?.forEach((slide) => {
              if (!slide.hasAttribute("hold")) {
                slide?.setAttribute("hold", true);
              }
            });
          } else {
            var slide_visibles = _this.querySelectorAll(
              ".swiper-slide motion-element:not([data-image])"
            );
            slide_visibles?.forEach((slide) => {
              if (!slide.hasAttribute("hold")) {
                slide?.setAttribute("hold", true);
              }
            });
          }

          setTimeout(() => {
            if (_this.classList.contains("slideshow")) {
              const motionElement = _this.querySelectorAll(
                `.swiper-slide.swiper-slide-active  motion-element.effect_fadeinup, .swiper-slide.swiper-slide-active  motion-element.motion-image`
              );
              motionElement &&
                motionElement.forEach((item) => {
                  item.refreshAnimation();
                });
            }
          }, 50);
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add("active");
          }
        },
      },
    });
  }

  initSecTiktok(sec) {
    sec.querySelectorAll(".swiper-slide").forEach((arrow) => {
      const tiktok = arrow.querySelector(".section_tiktok-image");
      let width = "--item-width: " + arrow.offsetWidth;
      tiktok.setAttribute("style", width);
    });
  }
}
customElements.define("slide-section", SlideSection);

class PopupBase extends HTMLElement {
  constructor() {
    super();
    this.customClass = this.dataset.customClass;
    this.modal = null;
  }

  initPopup(content, text, customClass) {
    const _this = this;
    this.modal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ["overlay", "button", "escape"],
      cssClass: [this.customClass || customClass],
      onOpen: function () {
        document.dispatchEvent(new CustomEvent("modal:opened"));
        document.documentElement.classList.add("open-popup");
        root.style.setProperty(
          "padding-right",
          getScrollBarWidth.init() + "px"
        );
        const video = this.modalBox.querySelector("video");
        if (!video) return;
        video.play();
        if (this.modal.classList.contains("shopable-video")) {
          video.muted = false;
        }
      },
      onClose: function () {
        document.dispatchEvent(new CustomEvent("modal:closed"));
        document.documentElement.classList.remove("open-popup");
        root.style.removeProperty("padding-right");
      },
      beforeClose: function () {
        _this.onCloseEvent();
        document.documentElement.classList.remove("open-popup");
        root.style.removeProperty("padding-right");
        return true;
      },
    });
    this.modal.setHeader = function (content) {
      let popup_content = this.modalBoxContent;
      let popup_header = document.createElement("div");
      popup_header.classList.add("tingle-modal-box__header");
      popup_header.innerHTML = content;
      let parentElement = popup_content.parentNode;
      parentElement.insertBefore(popup_header, popup_content);
    };
    if (text) {
      this.modal.setHeader(text);
    }

    this.modal.setContent(content);
    this.modal.open();
  }

  onClose() {
    this.modal.close();
  }
  onCloseEvent() {}
}

class SwatchInit extends HTMLElement {
  constructor() {
    super();
    this.options = null;
    this.init();
  }

  init() {
    const _this = this;
    this.querySelectorAll(".product__color-swatches--js").forEach((btn) => {
      _this.checkSwatches(btn);
    });
  }
  checkSwatches(e) {
    const { color, image, customValue, swatchType, optionSwatchValue } =
      e.dataset;
    if (color) {
      if (swatchType != "variant_images") {
        if (optionSwatchValue.length == 0 || optionSwatchValue == null) {
          if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
            if (image) {
              e.classList.add("color__" + color.replace(" ", "-"));
              e.style.backgroundColor = null;
              e.style.backgroundImage = "url('" + image + "')";
              e.style.backgroundSize = "cover";
              e.style.backgroundRepeat = "no-repeat";
            }
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      } else {
        if (optionSwatchValue == null || optionSwatchValue.length == 0) {
          if (image) {
            e.classList.add("color__" + color.replace(" ", "-"));
            e.style.backgroundColor = null;
            e.style.backgroundImage = "url('" + image + "')";
            e.style.backgroundSize = "cover";
            e.style.backgroundRepeat = "no-repeat";
          } else if (this.checkColor(color)) {
            e.style.backgroundColor = color;
            e.classList.add(customValue);
          } else {
            e.classList.add(customValue);
          }
        } else {
          e.style.setProperty("--swatch--background", optionSwatchValue);
        }
      }
    }
  }
  checkColor(strColor) {
    var s = new Option().style;
    s.color = strColor;
    return s.color == strColor;
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(".product__color-swatches--js.active"),
      (select) => select.getAttribute("data-value")
    );
    this.variantData.find((variant) => {
      if (this.options.length == 1) {
        const variantOptions = {
          1: variant.option1,
          2: variant.option2,
          3: variant.option3,
        };
        if (variantOptions[this.position_swatch] === this.options[0]) {
          this.options = variant.options;
        }
      }
    });
  }
  updateMasterId(variantData) {
    return (this.currentVariant = variantData.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    }));
  }
}

// js for 3d product - not done yet
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        deferredElement.play();
      }
    }
  }
}

function handleErrorMessagePopup(errorMessage = false) {
  const url = `${window.location.pathname}?section_id=form-message`;
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const elementErrorMessage = html.querySelector(
        ".product-form__error-message-wrapper"
      );
      const elementMessage = elementErrorMessage.querySelector(
        ".product-form__error-message"
      );
      elementMessage.textContent = errorMessage;
      showToast(elementErrorMessage.innerHTML, 5000, "modal-error");
    })
    .catch((e) => {
      throw e;
    });
}

function showToast(message, duration = 3000, customClass = "") {
  let toastContainer = document.getElementById("toast-container");
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    document.body.appendChild(toastContainer);
  }

  const toast = document.createElement("div");
  toast.className = `toast show ${customClass}`;
  toast.innerHTML = message;
  toastContainer.appendChild(toast);

  Motion.animate(
    toast,
    {
      opacity: [0, 1],
      scale: [0.3, 1],
    },
    {
      duration: 0.3,
      easing: "ease-out",
    }
  );

  setTimeout(() => {
    closeToast(toast);
  }, duration);
}

function closeToast(toast) {
  Motion.animate(
    toast,
    { opacity: 0, scale: 0.5 },
    { duration: 0.2, easing: "ease-in" }
  ).then(() => {
    toast.remove();
  });
}

class SlideLazyLoad {
  constructor(e) {
    (this.triggerEventsJs = e),
      (this.eventOptionsJs = { passive: !0 }),
      (this.userEventListenerJs = this.triggerListenerJs.bind(this)),
      (this.delayedScriptsJs = { normal: [], async: [], defer: [] });
  }
  triggerListenerJs() {
    this._removeUserInteractionListenerJs(this),
      "loading" === document.readyState
        ? document.addEventListener(
            "DOMContentLoaded",
            this._loadEverythingReadyNow.bind(this)
          )
        : this._loadEverythingReadyNow();
  }
  _removeUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.removeEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    );
  }
  _addUserInteractionListenerJs(e) {
    this.triggerEventsJs.forEach((t) =>
      window.addEventListener(t, e.userEventListenerJs, e.eventOptionsJs)
    );
  }
  _preloadAllScriptsJs() {
    document.body.classList.add("swiper-lazy");
    document.body.classList.add("review-lazy");
    const loadingSwiper = document.querySelectorAll(
      ".lazy-loading-swiper-after"
    );
    loadingSwiper.forEach((el) => {
      el.classList.remove("lazy-loading-swiper-after");
      this.initSlide(el);
    });
    const reviewProduct = document.querySelectorAll(".review-product-added");
    reviewProduct.forEach((el) => {
      el.classList.remove("review-product-added");
      el.innerHTML = el.querySelector(".product-review-json").innerHTML;
      el.classList.remove("inline-loading");
    });
  }

  initSlide(el) {
    const _this = el;
    var autoplaying = _this?.dataset.autoplay === "true";
    const loop = _this?.dataset.loop === "true";
    const itemDesktop = _this?.dataset.desktop ? _this?.dataset.desktop : 4;
    var itemTablet = _this?.dataset.tablet ? _this?.dataset.tablet : "";
    const itemMobile = _this?.dataset.mobile ? _this?.dataset.mobile : 1;
    const direction = _this?.dataset.direction
      ? _this?.dataset.direction
      : "horizontal";
    var autoplaySpeed = _this?.dataset.autoplaySpeed
      ? _this?.dataset.autoplaySpeed * 1000
      : 3000;
    var speed = _this?.dataset.speed ? _this?.dataset.speed : 400;
    const effect = _this?.dataset.effect ? _this?.dataset.effect : "slide";
    const row = _this?.dataset.row ? _this?.dataset.row : 1;
    var spacing = _this?.dataset.spacing ? _this?.dataset.spacing : 30;
    const progressbar = _this?.dataset.paginationProgressbar === "true";
    const autoItem = _this?.dataset.itemMobile === "true";
    const arrowCenterimage = _this?.dataset.arrowCenterimage
      ? _this?.dataset.arrowCenterimage
      : 0;
    spacing = Number(spacing);
    autoplaySpeed = Number(autoplaySpeed);
    speed = Number(speed);
    if (autoplaying) {
      autoplaying = { delay: autoplaySpeed };
    }
    if (!itemTablet) {
      if (itemDesktop < 2) {
        itemTablet = 1;
      } else if (itemDesktop < 3) {
        itemTablet = 2;
      } else {
        itemTablet = 3;
      }
    }
    if (direction == "vertical") {
      _this.style.maxHeight = _this.offsetHeight + "px";
    }
    _this.globalSlide = new Swiper(el, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      direction: direction,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: {
        rows: row,
        fill: "row",
      },
      navigation: {
        nextEl: _this.querySelector(".swiper-button-next"),
        prevEl: _this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el:
          _this.querySelector(".parent-pagination") ||
          _this.querySelector(".swiper-pagination"),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768: {
          slidesPerView: itemTablet,
          spaceBetween: spacing >= 30 ? 30 : spacing,
          pagination: {
            type: progressbar ? "progressbar" : "bullets",
          },
        },
        1025: {
          slidesPerView: itemDesktop,
          spaceBetween: spacing,
          pagination: {
            type: progressbar ? "progressbar" : "bullets",
          },
        },
      },
      thumbs: {
        swiper: this.thumbnailSlide ? this.thumbnailSlide : null,
      },

      on: {
        init: function (e) {
          var slide_visibles = _this.querySelectorAll(
            ".swiper-slide:not(.swiper-slide-visible) motion-element:not([data-image]),motion-element.swiper-slide:not(.swiper-slide-visible)"
          );
          slide_visibles?.forEach((slide) => {
            slide?.initialize();
          });
          e.autoplay.stop();
          if (_this?.dataset.autoplay === "true") {
            Motion.inView(
              _this,
              async () => {
                e.autoplay.start();
              },
              { margin: "0px 0px -50px 0px" }
            );
          }
          var sec__tiktok = _this.closest(".sec__tiktok-video");
          if (sec__tiktok) {
            _this.initSecTiktok(sec__tiktok);
            window.addEventListener("resize", function () {
              setTimeout(() => {
                _this.initSecTiktok(sec__tiktok);
              }, 150);
            });
          }
          if (arrowCenterimage) {
            var items_slide = _this.querySelectorAll(
              ".product-item__media--ratio"
            );
            if (items_slide.length != 0) {
              var oH = [];
              items_slide.forEach((e) => {
                oH.push(e.offsetHeight / 2);
              });
              var max = Math.max(...oH);
              var arrowsOffset = "--arrows-offset-top: " + max + "px";
              if (_this.querySelectorAll(".swiper-arrow")) {
                _this.querySelectorAll(".swiper-arrow").forEach((arrow) => {
                  arrow.setAttribute("style", arrowsOffset);
                });
              }
            }
          }
        },
        realIndexChange: function (swiper) {
          var slide_visibles = _this.querySelectorAll(
            ".swiper-slide motion-element:not([data-image])"
          );
          slide_visibles?.forEach((slide) => {
            if (!slide.hasAttribute("hold")) {
              slide?.setAttribute("hold", true);
            }
          });
        },
        slideChange: function () {
          const index_currentSlide = this.realIndex + 1;
          if (_this.closest(".sec__testimonials-single")) {
            const allDots = _this
              .closest(".sec__testimonials-single")
              .querySelectorAll(`single-item`);
            allDots.forEach((dot) => {
              dot.classList.remove("active");
            });
            _this
              .closest(".sec__testimonials-single")
              .querySelector(
                ".testimonials-author-image[data-position='" +
                  index_currentSlide +
                  "']"
              )
              .classList.add("active");
          }
        },
      },
    });
  }

  async _loadEverythingReadyNow() {
    this._preloadAllScriptsJs(),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.normal),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.defer),
      await this._loadScriptsFromListJs(this.delayedScriptsJs.async),
      await this._triggerDOMContentLoadedJs(),
      await this._triggerWindowLoadJs(),
      window.dispatchEvent(new Event("glozinspeed-allScriptsLoaded"));
  }
  async _loadScriptsFromListJs(e) {
    const t = e.shift();
    return t
      ? (await this._transformScript(t), this._loadScriptsFromListJs(e))
      : Promise.resolve();
  }
  async _transformScript(e) {
    return (
      await this._requestAnimFrame(),
      new Promise((t) => {
        const s = document.createElement("script");
        let n;
        [...e.attributes].forEach((e) => {
          let t = e.nodeName;
          "type" !== t &&
            ("data-glozinlazy-type" === t && ((t = "type"), (n = e.nodeValue)),
            s.setAttribute(t, e.nodeValue));
        }),
          e.hasAttribute("src")
            ? (s.addEventListener("load", t), s.addEventListener("error", t))
            : ((s.text = e.text), t()),
          e.parentNode.replaceChild(s, e);
      })
    );
  }
  async _triggerDOMContentLoadedJs() {
    (this.domReadyFired = !0),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event("glozinspeed-DOMContentLoaded")),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event("glozinspeed-DOMContentLoaded")),
      await this._requestAnimFrame(),
      document.dispatchEvent(new Event("glozinspeed-readystatechange")),
      await this._requestAnimFrame(),
      document.glozinonreadystatechange && document.glozinonreadystatechange();
  }
  async _triggerWindowLoadJs() {
    await this._requestAnimFrame(),
      window.dispatchEvent(new Event("glozinspeed-load")),
      await this._requestAnimFrame(),
      window.glozinonload && window.glozinonload(),
      await this._requestAnimFrame(),
      window.dispatchEvent(new Event("glozinspeed-pageshow")),
      await this._requestAnimFrame(),
      window.glozinonpageshow && window.glozinonpageshow();
  }
  async _requestAnimFrame() {
    return new Promise((e) => requestAnimationFrame(e));
  }
  static run() {
    const e = new SlideLazyLoad([
      "keydown",
      "mousemove",
      "touchmove",
      "touchstart",
      "touchend",
      "wheel",
    ]);
    e._addUserInteractionListenerJs(e);
  }
}
SlideLazyLoad.run();

// js for copy button
class CopyButton extends HTMLElement {
  constructor() {
    super();
    this.content = this.dataset.content;
    this.init();
  }
  init() {
    if (this.content) {
      this.addEventListener("click", this.onClick.bind(this));
    }
  }
  onClick() {
    navigator.clipboard.writeText(this.content);
    this.classList.add("copied");
  }
  updateUrl(newContent) {
    this.content = newContent;
  }
}
customElements.define("copy-button", CopyButton);





function openTab(event, tabId) {
    // Get all tab links and remove the 'active' class
    const tabLinks = document.querySelectorAll('.tab-link');
    tabLinks.forEach(link => link.classList.remove('active'));

    // Get all tab panes and hide them
    const tabPanes = document.querySelectorAll('.tab-pane');
    tabPanes.forEach(pane => pane.classList.remove('active'));

    // Add 'active' class to the clicked tab and corresponding content
    event.currentTarget.classList.add('active');
    document.getElementById(tabId).classList.add('active');
}

// Optionally, you can set a default active tab when the page loads
document.addEventListener('DOMContentLoaded', () => {
    document.querySelector('.tab-link').click(); // Simulate a click to activate the first tab
});


/* =============== cart functionality ================== */
//  function updateStepProgressBar() {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         const subtotal = cart.items_subtotal_price / 100;

//         const steps = [
//           { threshold: 399, el: document.getElementById("step-1") },
//           { threshold: 1000, el: document.getElementById("step-2") },
//           { threshold: 2500, el: document.getElementById("step-3") }
//         ];

//         const msg = document.getElementById("progress-text");
//         if (!msg) return; // If component not yet loaded

//         steps.forEach(s => s.el?.classList.remove('reached', 'completed'));

//         if (subtotal >= 2500) {
//           steps.forEach(s => s.el?.classList.add('completed'));
//           msg.textContent = `🎉 You've unlocked Free Delivery, 10% Off & Extra 5% Off!`;
//         } else if (subtotal >= 1000) {
//           steps[0].el?.classList.add('completed');
//           steps[1].el?.classList.add('completed');
//           steps[2].el?.classList.add('reached');
//           msg.textContent = `✅ 10% Off unlocked! Add ₹${(2500 - subtotal).toFixed(0)} more for extra 5% Off.`;
//         } else if (subtotal >= 399) {
//           steps[0].el?.classList.add('completed');
//           steps[1].el?.classList.add('reached');
//           msg.textContent = `✅ Free Delivery unlocked! Add ₹${(1000 - subtotal).toFixed(0)} more for 10% Off.`;
//         } else {
//           steps[0].el?.classList.add('reached');
//           msg.textContent = `Add ₹${(399 - subtotal).toFixed(0)} more for Free Delivery.`;
//         }
//       });
//   }
// ---- Anti-spam guards (added) ----
let _fspbTimer = null;
let _fspbFetching = false;
let _fspbLastSubtotal = null;

function _scheduleProgressUpdate(delay = 250) {
  clearTimeout(_fspbTimer);
  _fspbTimer = setTimeout(updateStepProgressBar, delay);
}

function updateStepProgressBar() {
  // Prevent overlapping /cart.js calls (added)
  if (_fspbFetching) return;
  _fspbFetching = true;

  fetch('/cart.js', { credentials: 'same-origin' })
    .then(res => res.json())
    .then(cart => {
      const subtotal = cart.items_subtotal_price / 100;

      // Optional: avoid DOM repaint if subtotal unchanged (added)
      if (_fspbLastSubtotal === subtotal) return;
      _fspbLastSubtotal = subtotal;

      const steps = [
        { threshold: 399, el: document.getElementById("step-1") },
        { threshold: 1000, el: document.getElementById("step-2") }
      ];

      const msg = document.getElementById("progress-text");
      if (!msg) return; // If component not yet loaded

      // Reset all steps
      steps.forEach(s => s.el?.classList.remove('reached', 'completed'));

      // --- Checkpoint logic ---
      if (subtotal >= 1000) {
        // ✅ Both rewards unlocked
        steps.forEach(s => s.el?.classList.add('completed'));
        msg.textContent = `🎉 Yay! Free Delivery + 10% Discount unlocked!`;

      } else if (subtotal >= 399) {
        // ✅ Free Delivery unlocked, next target = 10% off
        steps[0].el?.classList.add('completed');
        steps[1].el?.classList.add('reached');
        msg.textContent = `✅ Free Delivery unlocked! Add ₹${(1000 - subtotal).toFixed(0)} more for 10% Off on prepaid orders.`;

      } else {
        // 🚀 Below first checkpoint
        steps[0].el?.classList.add('reached');
        msg.textContent = `Add ₹${(399 - subtotal).toFixed(0)} more for Free Delivery.`;
      }
    })
    .catch(err => console.error("Error fetching cart:", err))
    .finally(() => {
      _fspbFetching = false; // (added)
    });
}


// Hook into Shopify add-to-cart AJAX call
function interceptAddToCartAjax() {
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    const url = args[0];

    // Trigger only on cart mutations; debounce instead of direct call (updated)
    if (typeof url === 'string' && (
      url.includes('/cart/add') ||
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/clear')
    )) {
      _scheduleProgressUpdate(300);
    }

    return response;
  };
}


// MutationObserver to cover dynamic mini-cart drawer (updated to prevent loop spam)
function observeDrawerLoad() {
  const targetNode = document.body;

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;

        // Only react when the progress bar (or a wrapper containing it) is inserted
        if (
          node.matches?.('free-ship-progress-bar') ||
          node.querySelector?.('free-ship-progress-bar')
        ) {
          _scheduleProgressUpdate(0);
          return;
        }
      }
    }
  });

  observer.observe(targetNode, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
  _scheduleProgressUpdate(0); // instead of direct update (updated)
  interceptAddToCartAjax();
  observeDrawerLoad();
});

// Also trigger on any cart interaction (updated to debounce)
document.body.addEventListener('click', function (e) {
  if (
    e.target.closest('[name="plus"]') ||
    e.target.closest('[name="minus"]') ||
    e.target.closest('[data-remove]') ||
    e.target.closest('[data-add-to-cart]') ||
    e.target.closest('[type="submit"]')
  ) {
    _scheduleProgressUpdate(500);
  }
});







(function () {
  let attempts = 0;
  const maxAttempts = 30; // 30 * 200ms = 6 seconds
  const intervalTime = 200;

  const interval = setInterval(() => {
    const specList = document.querySelector("#product-specification");
    const variantPicker = document.querySelector(".review_sold");

    if (specList && variantPicker) {
      clearInterval(interval);

      // Clone the list (or move it: see note below)
      const specClone = specList;

      // Create wrapper
      const wrapper = document.createElement("div");
      wrapper.className = "short-description-box";
      wrapper.appendChild(specClone);

      // Insert it AFTER the variant picker
      variantPicker.insertAdjacentElement("afterend", wrapper);

      console.log("✅ Short spec list inserted below variant picker.");
    } else {
      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(interval);
        console.warn("❌ Could not find spec list or variant picker.");
      }
    }
  }, intervalTime);
})();



document.querySelectorAll('.faq-question').forEach(button => {
  button.addEventListener('click', () => {
    const answer = button.nextElementSibling;
    const toggle = button.querySelector('.faq-toggle');
    const isOpen = answer.style.display === 'block';
    
    document.querySelectorAll('.faq-answer').forEach(a => a.style.display = 'none');
    document.querySelectorAll('.faq-toggle').forEach(t => t.textContent = '+');
    
    if (!isOpen) {
      answer.style.display = 'block';
      toggle.textContent = '−';
    }
  });
});



// Observe DOM changes to catch Judge.me badges
// const observer = new MutationObserver(() => {
//   document.querySelectorAll('.jdgm-prev-badge__text').forEach(el => {
//     if (!el.dataset.rounded) { // prevent double-rounding
//       const text = el.innerText;
//       const match = text.match(/([\d.]+)\/5/);
//       if (match) {
//         const rounded = Math.round(parseFloat(match[1]) * 10) / 10;
//         el.innerText = text.replace(match[1], rounded);
//         el.dataset.rounded = "true"; // mark as rounded
//       }
//     }
//   });
// });
// Start observing the whole body
// observer.observe(document.body, { childList: true, subtree: true });



function fixRatings() {
  document.querySelectorAll('.jdgm-prev-badge__text').forEach(el => {
    const text = el.innerText.trim();

    // match only the rating part inside "4.93/5 (196)"
    const match = text.match(/([\d.]+)\/5/);
    if (!match) return;

    const rating = parseFloat(match[1]);
    const rounded = Math.round(rating * 10) / 10;

    const newText = text.replace(match[1], rounded);

    if (el.innerText !== newText) {
      el.innerText = newText;
    }
  });
}
// run once
fixRatings();

// run repeatedly because Judge.me updates many times
const interval = setInterval(fixRatings, 1000);

// stop after 10 seconds (optional)
setTimeout(() => clearInterval(interval), 10000);

// Also observe DOM changes
const observer = new MutationObserver(() => fixRatings());
observer.observe(document.body, { childList: true, subtree: true });




// Doctor decommented video on product detail pages
document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.getElementById('openVideoModal');
  const modal = document.getElementById('videoModal');
  const iframe = document.getElementById('youtubeIframe');
  const closeBtn = document.querySelector('.video-close');

  if (!openBtn || !modal || !iframe) return;

  openBtn.addEventListener('click', function () {
    modal.style.display = 'flex';
    iframe.src = iframe.dataset.src + '&autoplay=1';
    document.body.style.overflow = 'hidden';
  });

  function closeModal() {
    modal.style.display = 'none';
    iframe.src = 'about:blank';
    document.body.style.overflow = '';
  }
  closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
}); 





/* Frequently Brought Together */

(function () {
  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  const moneyFormat = window.Shopify && window.Shopify.money_format
    ? window.Shopify.money_format
    : 'Rs. {{amount}}';

  const FBT_HANDLES = [
    'microfiber-pillow',
    'travel-pillow',
    'kids-bamboo-pillow',
    'cervical-pillow',
    'donut-pillow',
    'car-neck-pillow',
    'lumbar-support-pillow',
    'long-body-pillow',
    'contour-orthopedic-pillow',
    'small-memory-foam-pillow-with-cooling-gel',
    'wedge-pillow'
  ];

  const FBT_LIMIT = 11;

  let renderTimer = null;
  let addInProgress = false;
  let fbtProductsCache = {};
  let lastRenderedKey = '';
  let renderRequestId = 0;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision ?? 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) return '0';

      number = (number / 100).toFixed(precision);
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    return (format || moneyFormat).replace(/\{\{\s*(\w+)\s*\}\}/, function (_, placeholder) {
      switch (placeholder) {
        case 'amount':
          return withDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals':
          return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(cents, 0, '.', ',');
        default:
          return withDelimiters(cents, 2, ',', '.');
      }
    });
  }

  function setFbtStatus(message, type) {
    const mount = getActiveFbtMount();
    if (!mount) return;

    const box = mount.querySelector('[data-fbt-section]');
    if (!box) return;

    const statusEl = box.querySelector('.fbt-status');
    if (!statusEl) return;

    statusEl.className = 'fbt-status' + (type ? ' is-' + type : '');

    if (message) {
      statusEl.textContent = message;
      statusEl.style.display = 'block';
    } else {
      statusEl.textContent = '';
      statusEl.style.display = 'none';
    }
  }

  async function fetchCart() {
    const res = await fetch(root + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!res.ok) throw new Error('Cart fetch failed');
    return await res.json();
  }

  async function fetchProduct(handle) {
    if (fbtProductsCache[handle]) return fbtProductsCache[handle];

    const res = await fetch(root + 'products/' + handle + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) return null;

    const product = await res.json();
    fbtProductsCache[handle] = product;
    return product;
  }

  function updateHeaderCartCount(cart) {
    document.querySelectorAll('[data-cart-count], .cart-count, .header-cart-count, .js-cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function updateCartSubtotal(cart) {
    document.querySelectorAll('[data-cart-subtotal-price]').forEach(function (el) {
      el.innerHTML = formatMoney(cart.total_price, moneyFormat);
    });
  }

  function buildCard(product) {
    const variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    if (!variant) return '';

    const image = product.featured_image || (product.images && product.images[0]) || '';
    const compareAt = variant.compare_at_price;
    const discount = compareAt && compareAt > variant.price
      ? Math.round(((compareAt - variant.price) / compareAt) * 100)
      : 0;

    return `
      <div class="fbt-card" data-product-handle="${product.handle}">
        <div class="fbt-card-inner">
          <div class="img-btn">
            <a href="${product.url}" class="fbt-img-wrap">
              ${image ? `<img src="${image}" alt="${product.title}" class="fbt-img" loading="lazy">` : ''}
            </a>
            ${discount > 0 ? `<span class="fbt-badge">${discount}% off</span>` : `<span class="fbt-badge is-hidden"></span>`}
          </div>
          <div class="fbt-info">
            <a href="${product.url}" class="fbt-title">${product.title}</a>
            <div class="fbt-price-wrap">
              ${compareAt && compareAt > variant.price ? `<span class="fbt-compare">${formatMoney(compareAt, moneyFormat)}</span>` : ''}
              <span class="fbt-price">${formatMoney(variant.price, moneyFormat)}</span>
            </div>
            <div class="fbt-bottom">
              
              <button
                type="button"
                class="fbt-add-btn"
                data-variant-id="${variant.id}"
                data-handle="${product.handle}"
              >
                + Add
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function getActiveFbtMount() {
    const drawer = document.querySelector('#minicart_wrapper.open, #minicart_wrapper.active, #minicart_wrapper.show') || document.querySelector('#minicart_wrapper');
    if (!drawer) return null;

    const formWrap = drawer.querySelector('#minicart-form');
    if (!formWrap) return null;

    const mounts = Array.from(formWrap.querySelectorAll('[data-fbt-mount]'));
    if (!mounts.length) return null;

    const visible = mounts.filter(function (el) {
      return el.offsetParent !== null;
    });

    return visible[visible.length - 1] || mounts[mounts.length - 1];
  }

  function ensureFbtStructure() {
    const mount = getActiveFbtMount();
    if (!mount) return null;

    let box = mount.querySelector('[data-fbt-section]');

    if (!box) {
      mount.innerHTML = `
        <div class="custom-fbt-inner" data-fbt-section>
          <h3 class="fbt-heading">Frequently Bought Together</h3>
          <div class="fbt-status is-loading" style="display:none;"></div>
          <div class="fbt-slider">
            <div class="fbt-track"></div>
          </div>
        </div>
      `;
      box = mount.querySelector('[data-fbt-section]');
    }

    mount.style.display = '';
    return box;
  }

  async function renderFBT(force) {
    const requestId = ++renderRequestId;

    try {
      const cart = await fetchCart();
      if (requestId !== renderRequestId) return;

      const mount = getActiveFbtMount();
      if (!mount) return;

      const cartCount = Number(cart.item_count || 0);

      if (cartCount === 0) {
        mount.innerHTML = '';
        mount.style.display = 'none';
        return;
      }

      mount.style.display = '';

      let box = mount.querySelector('[data-fbt-section]');
      if (!box) {
        mount.innerHTML = `
          <div class="custom-fbt-inner" data-fbt-section>
            <h3 class="fbt-heading">Frequently Bought Together</h3>
            <div class="fbt-status is-loading" style="display:none;"></div>
            <div class="fbt-slider">
              <div class="fbt-track"></div>
            </div>
          </div>
        `;
        box = mount.querySelector('[data-fbt-section]');
      }

      const track = box.querySelector('.fbt-track');
      if (!track) return;

      const hasExistingCards = track.innerHTML.trim() !== '';

      if (!hasExistingCards) {
        setFbtStatus('Loading recommendations...', 'loading');
      } else {
        setFbtStatus('Updating recommendations...', 'loading');
      }

      const cartHandles = new Set((cart.items || []).map(function (item) {
        return item.handle;
      }));

      const filteredHandles = FBT_HANDLES.filter(function (handle) {
        return !cartHandles.has(handle);
      }).slice(0, FBT_LIMIT);

      const renderKey = filteredHandles.join('|');

      if (!force && renderKey === lastRenderedKey && track.innerHTML.trim() !== '') {
        setFbtStatus('', '');
        return;
      }

      lastRenderedKey = renderKey;

      if (!filteredHandles.length) {
        mount.innerHTML = '';
        mount.style.display = 'none';
        return;
      }

      const products = await Promise.all(
        filteredHandles.map(function (handle) {
          return fetchProduct(handle);
        })
      );

      if (requestId !== renderRequestId) return;

      const validProducts = products.filter(function (p) {
        return p && p.variants && p.variants.length;
      });

      if (!validProducts.length) {
        mount.innerHTML = '';
        mount.style.display = 'none';
        return;
      }

      track.innerHTML = validProducts.map(buildCard).join('');
      setFbtStatus('', '');
    } catch (err) {
      console.error('FBT render failed:', err);
      setFbtStatus('Unable to load recommendations.', 'error');
    }
  }

  async function refreshMiniCartForm() {
    const currentFormWrap = document.querySelector('#minicart-form');
    if (!currentFormWrap) return;

    const res = await fetch(root + '?section_id=minicart-form', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!res.ok) throw new Error('Failed to refresh minicart form');

    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const freshFormWrap = doc.querySelector('#minicart-form');
    if (!freshFormWrap) throw new Error('Fresh #minicart-form not found');

    currentFormWrap.replaceWith(freshFormWrap);
  }

  function keepDrawerOpen() {
    const wrapper = document.querySelector('#minicart_wrapper');
    const drawer = document.querySelector('#minicart_wrapper .minicart__wrapper');
    const overlay = document.querySelector('.overlayminicart');

        if (wrapper) {
      wrapper.classList.add('open', 'active', 'is-open', 'show');
      wrapper.setAttribute('aria-hidden', 'false');
    }

    if (drawer) {
      drawer.classList.add('open', 'active', 'is-open', 'show');
      drawer.setAttribute('aria-hidden', 'false');
    }

    if (overlay) {
      overlay.classList.add('open', 'active', 'show');
    }

    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden', 'drawer-open', 'cart-open');
  }

  async function addFbtProduct(variantId, button) {
    if (!variantId || !button || addInProgress) return;

    addInProgress = true;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Adding...';
    setFbtStatus('Adding product to cart...', 'loading');

    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }]
        })
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.description || data.message || 'Add to cart failed');
      }

      const cart = await fetchCart();

      updateHeaderCartCount(cart);
      updateCartSubtotal(cart);

      setFbtStatus('Refreshing cart...', 'loading');
      await refreshMiniCartForm();
      keepDrawerOpen();

      lastRenderedKey = '';
      await renderFBT(true);

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    } catch (err) {
      console.error('FBT add failed:', err);
      setFbtStatus('Failed to add product.', 'error');
    } finally {
      addInProgress = false;
      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = '+ Add';
    }
  }

  function scheduleRenderFBT(delay, force) {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(function () {
      if (addInProgress) return;
      if (force) lastRenderedKey = '';
      renderFBT(!!force);
    }, delay || 200);
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.fbt-add-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    addFbtProduct(btn.getAttribute('data-variant-id'), btn);
  });

  document.addEventListener('DOMContentLoaded', function () { 
    scheduleRenderFBT(400, true);
  });

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    setTimeout(function () {
      scheduleRenderFBT(700, true);
    }, 700);

    setTimeout(function () {
      scheduleRenderFBT(1200, true);
    }, 1200);
  });

  document.addEventListener('cart:updated', function () {
    scheduleRenderFBT(300, true);
  });

  document.addEventListener('click', function (e) {
    const cartOpenTrigger = e.target.closest('.mini-cart-icon, .cart-icon, .open-cart, .header-cart, [data-cart-open], [data-cart-trigger]');
    if (!cartOpenTrigger) return;

    scheduleRenderFBT(500, true);
  });

  function waitForFbtMountAndRender() {
    let tries = 0;
    const maxTries = 20;

    const timer = setInterval(function () {
      tries += 1;

      const mount = getActiveFbtMount();
      if (mount) {
        clearInterval(timer);
        lastRenderedKey = '';
        renderFBT(true);
        return;
      }

      if (tries >= maxTries) {
        clearInterval(timer);
      }
    }, 150);
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.quantity__button, .cart-item__qty, .js-qty__adjust, .qty-minus, .qty-plus, .cart-remove, .remove, [data-cart-remove], [name="minus"], [name="plus"], mini-cart-remove-button a');
    if (!trigger) return;

    const isDelete = !!e.target.closest('.cart-remove, .remove, [data-cart-remove], mini-cart-remove-button a');

    if (isDelete) {
      setTimeout(function () {
        waitForFbtMountAndRender();
      }, 900);

      setTimeout(function () {
        waitForFbtMountAndRender();
      }, 1600);

      setTimeout(function () {
        waitForFbtMountAndRender();
      }, 2400);
    } else {
      setTimeout(function () {
        waitForFbtMountAndRender();
      }, 700);

      setTimeout(function () {
        waitForFbtMountAndRender();
      }, 1300);
    }
  });

  window.renderFBT = function () {
    lastRenderedKey = '';
    setFbtStatus('Loading recommendations...', 'loading');
    renderFBT(true);
  };
})();

/* Frequently Brought Together */